// Version of the running build. scripts/deploy-hosting.sh creates a git tag (e.g. V2.1.0, V2.1.0-beta.1) before publishing and
// builds with REACT_APP_VERSION=<that tag>, so the number shown in the app is the tag that exists in git for this exact code.
// A local `npm start` has no tag and shows "dev".
export const APP_VERSION = process.env.REACT_APP_VERSION || "dev";
// branch@commit of the build, shown as a tooltip and in the logs (empty on a local run)
export const BUILD_INFO = process.env.REACT_APP_BUILD_INFO || "";
